import { render, staticRenderFns } from "./Brothers.vue?vue&type=template&id=72690bb6&scoped=true&"
import script from "./Brothers.vue?vue&type=script&lang=js&"
export * from "./Brothers.vue?vue&type=script&lang=js&"
import style0 from "./Brothers.vue?vue&type=style&index=0&id=72690bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72690bb6",
  null
  
)

export default component.exports